export const useFilePicker = _ref => {
  let {
    onFilePicked
  } = _ref;
  const openFilePicker = () => {
    const input = document.createElement('input');
    input.type = 'file';
    input.accept = '.jpg,.jpeg,.png';
    input.onchange = event => {
      var _files;
      onFilePicked((_files = event.target.files) == null ? void 0 : _files[0]);
    };
    input.click();
  };
  return {
    openFilePicker
  };
};
//# sourceMappingURL=useFilePicker.js.map